module.exports = __webpack_public_path__ + "static/fonts/Mont-Thin.f336ce8.woff";